import script from "./productEventMexDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./productEventMexDialog.vue?vue&type=script&setup=true&lang=js"

import "./productEventMexDialog.vue?vue&type=style&index=0&id=7b0d2f78&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0d2f78"]])

export default __exports__